import React, { useEffect, useState } from 'react'
import Empty from '../feedback/Empty'
import { MdOutlineRestore } from 'react-icons/md'
import adminServices from '../../services/AdminServices';
import moment from 'moment';
import utils from '../../utils';
import Loading from '../feedback/Loading';
import FetchError from '../feedback/FetchError';
import RequestModal from '../requests/RequestModal';
import { Link } from 'react-router-dom';

function RecentRecords() {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState();
    const [requests, setRequests] = useState();
    const [action, setAction] = useState(0);
    const [activeRequest, setActiveRequest] = useState(null);

    useEffect(() => {
        getRecords()
    }, [])
    useEffect(() => { }, [activeRequest])

    const getRecords = () => {
        setError();
        setLoading(true);
        adminServices.getRequests('')
            .then(res => {
                setRequests(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError(err);
                setLoading(false);
            });
    }

    function openModal(action, user = null) {
        const openBtn = document.getElementById("request-create-open-btn");
        setAction(action);
        setActiveRequest(user);
        if (openBtn) openBtn.click();
    }

    return (
        <div className='space-y-3'>
            <h3 className="text-xl font-bold text-gray-800 flex gap-3 items-center">
                <MdOutlineRestore className='h-7 w-7' /> Recent Records
            </h3>
            <RequestModal
                action={action}
                activeRequest={activeRequest}
                onReload={getRecords}
                setActiveRequest={setActiveRequest}
            />
            {loading ? (
                <div className="py-9">
                    <Loading />
                </div>
            ) : error ? (
                <FetchError error={error} />
            ) : (
                <div className="bg-surface-light dark:bg-surface-dark rounded-xl border border-border-light dark:border-border-dark overflow-hidden">
                    <div className='overflow-x-auto'>
                        <table className="table table-compact table-zebra w-full">
                            <thead>
                                <tr>
                                    <th>Patient</th>
                                    <th className='hidden md:table-cell'>Nurse</th>
                                    <th className='hidden md:table-cell'>Location</th>
                                    <th className='hidden md:table-cell'>Urgency</th>
                                    <th className='hidden md:table-cell'>Care Needs</th>
                                    <th className='hidden md:table-cell'>Created</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {requests?.results?.length > 0 ? (
                                    requests.results.slice(0, 5)?.map((request) => (
                                        <tr key={request.id}>
                                            <td>
                                                <Link to={`/patient/${request?.patient?.id}`} className="flex gap-3 items-center group hover:cursor-pointer">
                                                    <div className="hidden md:avatar placeholder">
                                                        {request?.patient?.user?.image ? (
                                                            <div className="w-16 rounded-full">
                                                                <img src={request?.patient.user.image} alt={request?.patient.user.full_name} />
                                                            </div>
                                                        ) : (
                                                            <div className="bg-neutral text-white rounded-full w-16">
                                                                <span className="text-lg">
                                                                    {utils.makeProfileLetter(request?.patient.user)}
                                                                </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                    <div>
                                                        {request?.patient?.user?.full_name && (
                                                            <p className="font-bold group-hover:underline">{request?.patient.user.full_name}</p>
                                                        )}
                                                        <p className="text-gray-600">
                                                            {request?.patient?.user?.phone_number ? (
                                                                <span>{request?.patient?.user?.phone_number}</span>
                                                            ) : (
                                                                <span>{request?.patient?.user?.email}</span>
                                                            )}
                                                        </p>
                                                    </div>
                                                </Link>
                                            </td>
                                            <td className='hidden md:table-cell'>
                                                {request.get_assigned_nurse ? (
                                                    <Link to={`/nurse/${request.get_assigned_nurse.nurse.id}`} className='flex gap-3 items-center group hover:cursor-pointer'>
                                                        <div className="hidden md:avatar placeholder">
                                                            {request.get_assigned_nurse.nurse?.user?.image ? (
                                                                <div className="w-16 rounded-full">
                                                                    <img
                                                                        src={request.get_assigned_nurse.nurse.user.image}
                                                                        alt={request.get_assigned_nurse.nurse.user.full_name}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <div className="bg-neutral text-white rounded-full w-16 flex items-center justify-center">
                                                                    <span className="text-lg">
                                                                        {utils.makeProfileLetter(request.get_assigned_nurse.nurse.user)}
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                        <div>
                                                            <p className="font-bold group-hover:underline">{request.get_assigned_nurse.nurse.user.full_name}</p>
                                                            <p className="text-gray-600">
                                                                {request.get_assigned_nurse.nurse.user.phone_number ? (
                                                                    <span>{request.get_assigned_nurse.nurse.user.phone_number}</span>
                                                                ) : (
                                                                    <span>{request.get_assigned_nurse.nurse.user.email}</span>
                                                                )}
                                                            </p>
                                                        </div>
                                                    </Link>
                                                ) : '—'}
                                            </td>
                                            <td className='hidden md:table-cell'>
                                                {request.location_preference?.address}
                                            </td>

                                            <td className='hidden md:table-cell'>
                                                {request.urgency_level}
                                            </td>
                                            <td className='hidden md:table-cell'>
                                                {(() => {
                                                    const skills = request.requested_skills || [];
                                                    if (skills.length === 0) return '—';
                                                    const displayed = skills.slice(0, 2).map(s => s.name);
                                                    return skills.length > 2 ? displayed.join(', ') + ', ...' : displayed.join(', ');
                                                })()}
                                            </td>
                                            <td className='hidden md:table-cell'>
                                                {moment(request.creation_time).format("MMM Do YYYY")}
                                            </td>
                                            <td>
                                                <span className={`px-2 py-1 rounded text-xs ${request.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                                                    request.status === 'Matched' ? 'bg-blue-100 text-blue-800' :
                                                        request.status === 'Accepted' ? 'bg-purple-100 text-purple-800' :
                                                            request.status === 'Completed' ? 'bg-green-100 text-green-800' :
                                                                'bg-red-100 text-red-800'
                                                    }`}>
                                                    {request.status}
                                                </span>
                                            </td>
                                            <td>
                                                <button
                                                    onClick={() => openModal(1, request)}
                                                    className="btn btn-secondary btn-sm">
                                                    View
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : null}
                            </tbody>
                        </table>
                        {requests?.results?.length === 0 ? (
                            <div className="p-3">
                                <Empty objectName={'Requests'} />
                            </div>
                        ) : null}
                    </div>
                </div>
            )}
        </div>
    )
}

export default RecentRecords